export function waveMaskUtils() {
  $(document).ready(function() {
    function updatePadding() {
      // Calculate the aspect ratio padding based on 1640/180 for 100vw
      const aspectRatioPadding = ( 180 / 1640 ) * 100 + 'vw';

      // Update padding-top for .compensate-spacing
      $('.compensate-spacing:not(.page-header__content)').css('padding-top', aspectRatioPadding);
      $('.compensate-spacing.page-header__content').css('padding-top', `calc(${aspectRatioPadding} / 5)`);

      // Check if parent has class 'next-section-is-mask' and update padding-bottom
      $('.next-section-is-mask .compensate-spacing:not(.page-header__content)').css('padding-bottom', aspectRatioPadding);
      $('.next-section-is-mask .compensate-spacing.page-header__content').css('padding-bottom', `calc(${aspectRatioPadding} - (${aspectRatioPadding} / 4))`);

      // Set the CSS variable for aspect ratio padding
      $(':root').css('--aspectRatioPadding', aspectRatioPadding);
    }

    // Initial update
    updatePadding();

    // Update on window resize
    $(window).resize(function() {
      updatePadding();
    });
  });

  // Wave Masks
  $('.wave-mask, .wave-mask-group').each(function() {
    // Find the previous sibling element
    const $prevSibling = $(this).prev();

    // Check if the previous sibling exists to avoid errors
    if ($prevSibling.length) {
      // If the previous sibling exists, add the 'next-section-is-mask' class to it
      $prevSibling.addClass('next-section-is-mask');
    } else if ($(this).parent().hasClass('entry-content')) {
      // If the previous sibling does not exist and the parent has the class 'entry-content',
      // add the 'next-section-is-mask' class to the previous sibling of the parent element
      $(this).parent().prev().addClass('next-section-is-mask');
    }
  });

  $('section:not(.is-style-hero)').each(function() {
    // Find the next sibling element
    const $nextSibling = $(this).next();

    // Check if the next sibling is asc or desc wave
    if ($nextSibling.hasClass('wave-mask--desc')) {
      // Add class for respective wave type
      $(this).addClass('next-section-is-mask--desc');
    }
  });

  $('.wave-mask-group').each(function() {
    // Find the next sibling element
    const $nextSibling = $(this).next();

    // Check if the next sibling has a height of 0
    if ($nextSibling.height() === 0) {
      // Find the next sibling of the next sibling element
      const $nextNextSibling = $nextSibling.next();
      // Check if the next sibling of the next sibling has the class 'wave-mask'
      if ($nextNextSibling.hasClass('wave-mask')) {
        // If it does, add the 'next-section-is-mask' class to the last '.wave-mask' element
        // within the current '.wave-mask-group'
        $(this).find('.wave-mask').last().addClass('next-section-is-mask');
      }
    }
  });
}
